import React, { Component } from 'react';
import { Toast, WhiteSpace } from 'antd-mobile';
import axios from "axios";
import logo from "../assects/img/logo.png";
import storage from "../model/storage";
import yylogo from "../assects/img/yy_code.png";
import "../assects/css/Countdown.css";
class Countdown extends Component {
    constructor(props) {
        super(props);
        this.state = {

            hour: 0,
            minute: 0,
            second: 0,
            examName:"",
            paperName:""


        }
    }
   
    componentWillMount(){
        document.title="考试倒计时_估分模考系统_山香教育";
        if(this.props.location.state&&this.props.location.state.examId){
      
        }else{
          this.props.history.replace(`/?examId=${storage.get("examId")}&paperId=${storage.get("paperId")}&market=${storage.get("market")}`);
          window.location.reload();
        }
    }
    componentDidMount() {
        var that=this;
        axios.get(storage.baseUrl+'/countDown', {
            params: {
              examId: that.props.location.state.examId,
              paperId: that.props.location.state.paperId,
              userId:that.props.location.state.userId
            }
          })
            .then(function (response) {
                //console.log(response);
            if(response.data.code === "0000"){
               // const end = Date.parse(response.data.startTime);
                that.countFun(response.data.startTime);
                that.setState({
                    examName:response.data.examInfo.examName,
                    paperName:response.data.paperInfo.paperName
                })
            }else{
                Toast.info(response.data.message, 1);
            }
              
             
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })


        
    }


    componentWillUnmount() {

        clearInterval(this.timer);
    }

    countFun = (end) => {
        //console.log(end);
        let now_time = Date.parse(new Date());
        var remaining = parseInt(end) - now_time;

        this.timer = setInterval(() => {
            //防止出现负数
            if (remaining > 1000) {
                remaining -= 1000;
                let day = Math.floor((remaining / 1000 / 3600) / 24);
                let hour = Math.floor((remaining / 1000 / 3600) % 24);
                let minute = Math.floor((remaining / 1000 / 60) % 60);
                let second = Math.floor(remaining / 1000 % 60);
                let dayNum=day*24+hour;
                this.setState({
                    day: day,
                    hour: dayNum < 10 ? "0" + dayNum : dayNum,
                    minute: minute < 10 ? "0" + minute : minute,
                    second: second < 10 ? "0" + second : second
                })
            } else {
                clearInterval(this.timer);
                //倒计时结束时触发父组件的方法
                if(this.props.location.state.examType==="1"){
                    this.props.history.push( { pathname: "/Mk", state: {examType:this.props.location.state.examType,examId:this.props.location.state.examId,paperId:this.props.location.state.paperId,userId:this.props.location.state.userId} });
                    }else{
                    this.props.history.push( { pathname: "/GF", state: {examType:this.props.location.state.examType,examId:this.props.location.state.examId,paperId:this.props.location.state.paperId,userId:this.props.location.state.userId} });
                    }
                
            }
        }, 1000);
    }

    render() {


        return (
            <div className="login_con">
                <img src={logo} className="res_logo" alt="logo" />
                {
                    this.props.location.state.examType==="1"?<p className="cut_title">距离模考开始时间还有</p>
                    :<p className="cut_title">距离估分开始时间还有</p>
                }
                
                <p className="cut_con"><i></i><span>{this.state.hour}</span>时<span>{this.state.minute}</span>分<span>{this.state.second}</span>秒</p>
                <div className="yy_con">
                    <p className="yy_title">预约成功</p>
                    
                     {
                    this.props.location.state.examType==="1"?
                    <p className="yy_text yy_tip">恭喜你已经成功获得了<span className="red_bz">{this.state.examName}
                    {this.state.paperName}</span>模考资格，模考会在倒计时结束后开始，请耐心等候！</p>
                    : <p className="yy_text yy_tip">恭喜你已经成功获得了<span className="red_bz">{this.state.examName}
                    {this.state.paperName}</span>估分资格，估分会在倒计时结束后开始，请耐心等候！</p>
                     }
                     {
                    this.props.location.state.examType==="1"?
                    <p className="yy_text">为保证快速找到模考入口：</p>
                    :<p className="yy_text">为保证快速找到估分入口：</p>
                     }
                    
                    
                    <p className="yy_text"><i></i>1、点击<br />
                        <a href="https://www.shanxiangjiaoyu.com/">https://www.shanxiangjiaoyu.com/</a>
                        <br />
                        进入山香教育官网首页，即可找到入口</p>
                        {
                    this.props.location.state.examType==="1"?
                    <p className="yy_text"><i></i>2、长按或扫描下方二维码，关注“山香教育”公众号，回复“模考”，即可获取模考链接</p>
                    :  <p className="yy_text"><i></i>2、长按或扫描下方二维码，关注“山香教育”公众号，回复“估分”，即可获取估分链接</p>
                     }
                  
                    <img src={yylogo} className="yyLogo" />
                </div>

            </div>
        );
    }
}

export default Countdown;
